import { ConfirmationDialog } from 'components';
import { useTranslation } from 'libs/i18n';
import { DialogProps } from 'libs/ui';

export interface DialogConfirmRevokeOtpVerificationProps
  extends Pick<DialogProps, 'isOpen' | 'onClose'> {
  loading?: boolean;
  fullName: string;
  onConfirm: () => void;
}

export const DialogConfirmRevokeOtpVerification = ({
  loading,
  isOpen,
  fullName,
  onConfirm,
  onClose,
}: DialogConfirmRevokeOtpVerificationProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmationDialog
      fullWidth
      headerCentered
      confirmButtonColorVariant="red"
      confirmButtonLabel={t(
        'components.dialogConfirmRevokeOtpVerification.confirmLabel'
      )}
      isOpen={isOpen}
      loading={loading}
      maxWidth="sm"
      subtitle={t('components.dialogConfirmRevokeOtpVerification.subtitle', {
        fullName,
      })}
      title={t('components.dialogConfirmRevokeOtpVerification.title')}
      onBack={onClose}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
